import { render, staticRenderFns } from "./ColumnContacts.vue?vue&type=template&id=4065a4f8"
import script from "./ColumnContacts.vue?vue&type=script&lang=js"
export * from "./ColumnContacts.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports